import React from "react";
import {
    Box,
    Select,
    Input,
    Checkbox,
    Stack,
} from "@chakra-ui/react";

export interface PartsFilterState {
    // Core filters
    oem: "all" | "oem" | "aftermarket";
    minPrice?: number;
    maxPrice?: number;
    inStockOnly: boolean;

    // Text filters
    title?: string;
    partNumber?: string;
}

interface Props {
    filters: PartsFilterState;
    onChange: React.Dispatch<React.SetStateAction<PartsFilterState>>;
}

const PartsFilters: React.FC<Props> = ({ filters, onChange }) => {
    return (
        <Box
            p={4}
            mb={6}
            borderWidth="1px"
            borderRadius="md"
            bg="white"
        >
            <Stack
                spacing={4}
                direction={{ base: "column", md: "row" }}
                flexWrap={{ base: "wrap", md: "nowrap" }}
            >
                {/* OEM */}
                <Select
                    value={filters.oem}
                    onChange={(e) =>
                        onChange((prev) => ({
                            ...prev,
                            oem: e.target.value as "all" | "oem" | "aftermarket",
                        }))
                    }
                >
                    <option value="all">All Parts</option>
                    <option value="oem">OEM Only</option>
                    <option value="aftermarket">Aftermarket Only</option>
                </Select>

                {/* Title */}
                <Input
                    placeholder="Search by title"
                    value={filters.title ?? ""}
                    onChange={(e) =>
                        onChange((prev) => ({
                            ...prev,
                            title: e.target.value || undefined,
                        }))
                    }
                />

                {/* Part Number */}
                <Input
                    placeholder="Search by part number"
                    value={filters.partNumber ?? ""}
                    onChange={(e) =>
                        onChange((prev) => ({
                            ...prev,
                            partNumber: e.target.value || undefined,
                        }))
                    }
                />

                {/* Min Price */}
                <Input
                    placeholder="Min price"
                    type="number"
                    value={filters.minPrice ?? ""}
                    onChange={(e) =>
                        onChange((prev) => ({
                            ...prev,
                            minPrice: e.target.value
                                ? Number(e.target.value)
                                : undefined,
                        }))
                    }
                />

                {/* Max Price */}
                <Input
                    placeholder="Max price"
                    type="number"
                    value={filters.maxPrice ?? ""}
                    onChange={(e) =>
                        onChange((prev) => ({
                            ...prev,
                            maxPrice: e.target.value
                                ? Number(e.target.value)
                                : undefined,
                        }))
                    }
                />

                {/* In Stock */}
                <Checkbox
                    isChecked={filters.inStockOnly}
                    onChange={(e) =>
                        onChange((prev) => ({
                            ...prev,
                            inStockOnly: e.target.checked,
                        }))
                    }
                    whiteSpace="nowrap"
                >
                    In stock only
                </Checkbox>
            </Stack>
        </Box>
    );
};

export default PartsFilters;
